<template>
    <kiosk-group-details :teamId="props.teamId" :groupId="props.groupId">
        <div class="col-span-12 lg:col-span-10 flex flex-col w-full justify-center">
            <div class="max-w-(--breakpoint-sm) flex flex-col">
                <page-callout section="kiosk-group-billing-details" class="mb-4" />

                <page-header>Billing Details</page-header>

                <group-billing-email
                    class="mb-4"
                    :teamId="group.team_id"
                    :groupId="group.group_id"
                    :billingEmail="group.billing_email"
                    :isEditable="isEditable"
                />

                <group-billing-info
                    class="mb-4"
                    :teamId="group.team_id"
                    :groupId="group.group_id"
                    :billingInformation="{
                        billing_company_legal_name: group.billing_company_legal_name,
                        billing_address: group.billing_address,
                        billing_address_line_2: group.billing_address_line_2,
                        billing_city: group.billing_city,
                        billing_state: group.billing_state,
                        billing_zip: group.billing_zip,
                        billing_country: group.billing_country,
                        billing_po_number: group.billing_po_number,
                    }"
                    :isEditable="isEditable"
                />

                <group-stripe-customer v-if="stripeKey && isEditable" class="mb-4" :stripeId="group.stripe_id" />
            </div>
        </div>
    </kiosk-group-details>
</template>

<script setup>
import KioskGroupDetails from '~/components/kiosk/kiosk-groups/details/KioskGroupDetails.vue';
import { useGroupDetails } from '~/components/kiosk/kiosk-groups/composables/useGroupDetails';
import PageHeader from '~/components/general/PageHeader.vue';
import PageCallout from '~/components/general/PageCallout.vue';
import GroupBillingEmail from '~/components/settings/billing/GroupBillingEmail.vue';
import GroupBillingInfo from '~/components/settings/billing/GroupBillingInfo.vue';
import GroupStripeCustomer from '~/components/settings/billing/GroupStripeCustomer.vue';
import { computed } from 'vue';

const { group } = useGroupDetails();

const props = defineProps({
    teamId: { type: Number, required: true },
    groupId: { type: String, required: true },
});

const stripeKey = Spark.stripeKey;
const isEditable = computed(() => group.value.is_billable);
</script>
